import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import SplashScreen from "@/components/site/SplashScreen";

function App() {
  return (
    <div className="App">
      <SplashScreen />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        richColors
        toastOptions={{
          classNames: { toast: "font-display" },
        }}
      />
    </div>
  );
}

export default App;
